import { render, staticRenderFns } from "./waterAffairs.vue?vue&type=template&id=1bbffafa&scoped=true&"
import script from "./waterAffairs.vue?vue&type=script&lang=js&"
export * from "./waterAffairs.vue?vue&type=script&lang=js&"
import style0 from "./waterAffairs.vue?vue&type=style&index=0&id=1bbffafa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbffafa",
  null
  
)

export default component.exports